import { SpeciesAiSearchScreen } from '@screens/SpeciesSearch/SpeciesAiSearchScreen/SpeciesAiSearchScreen';

export default function EditReportSpeciesAiScreen(): React.ReactNode {
  return <SpeciesAiSearchScreen />;
}
